'use strict';

module.exports = '2.26.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 331
// module chunks = 142807904292071